import React, { Suspense } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { DownloadOutline } from '@lyearn/icons';
import { ActionMenu, ActionMenuProps } from '@lyearn/molecules';
import { LinkButton, Typography } from '@lyearn/ui';

import ActionDialogs from './components/ActionDialogs';
import useAddTasks from './hooks/useAddTasks';
import { AddTaskButtonProps, AddTaskMenuAction } from './types';

const OVERRIDES: ActionMenuProps['overrides'] = {
  PopoverContent: {
    position: 'bottom-start',
  },
};

function AddTaskButton(props: AddTaskButtonProps) {
  const { t } = useTranslation('OKRs');
  const { entityId, entity, fileId } = props;
  const { state, methods } = useAddTasks(props);
  const { inViewDialogState, menuItems } = state;
  const { onClose, onMenuItemAction } = methods;

  if (!menuItems.length) {
    return null;
  }

  return (
    <>
      <ActionMenu<AddTaskMenuAction>
        items={menuItems}
        minWidth={21.2}
        overrides={OVERRIDES}
        onAction={onMenuItemAction}>
        <LinkButton className="py-2 px-4" color={'internal'} startIcon={<DownloadOutline />}>
          <Typography variant="heading-xxs">{t('Task:Import')}</Typography>
        </LinkButton>
      </ActionMenu>
      <Suspense fallback={null}>
        <ActionDialogs
          entity={entity}
          entityId={entityId}
          fileId={fileId}
          inViewDialog={inViewDialogState?.inViewDialog}
          provider={inViewDialogState?.provider}
          onClose={onClose}
          onSubmit={props.onClose} // to close parent popup as well
        />
      </Suspense>
    </>
  );
}

export default AddTaskButton;
